<main id="content" class="js-content" role="main">
        <div class="grid-row">
            <header>
                <h1 class="heading-xlarge">Redirecting</h1>
            </header>
            <div class="notice">
                <strong class="visually-hidden">Please wait</strong>
                <strong class="aa-copy-size">
                    Redirecting to <a routerLink="/">home page</a>
                </strong>
            </div>
        </div>

</main>
